// Readers
import employeeReader from 'tbase/readers/Employee'; // Utils

import joinTruthyValues from '../../utils/joinTruthyValues';
export var getEmployeeFirstName = function getEmployeeFirstName(employee) {
  return employeeReader.firstName(employee) || employeeReader.fname(employee);
};
export var getEmployeeLastName = function getEmployeeLastName(employee) {
  return employeeReader.lastName(employee) || employeeReader.lname(employee);
};
export var getEmployeeFullName = function getEmployeeFullName(employee) {
  var employeeFirstName = getEmployeeFirstName(employee);
  var employeeLastName = getEmployeeLastName(employee);
  var employeeFullName = joinTruthyValues([employeeFirstName, employeeLastName], ' ');
  return employeeFullName;
};
export var getEmployeeName = function getEmployeeName(employee) {
  var employeeName = employeeReader.userName(employee);
  if (employeeName) return employeeName;
  var displayName = employeeReader.displayName(employee);
  if (displayName) return displayName;
  return getEmployeeFullName(employee);
};
export var getEmployeeId = function getEmployeeId(employee) {
  var displayNumber = employeeReader.displayNumber(employee);
  var id = employeeReader.id(employee);
  var externalId = employeeReader.externalId(employee);
  return displayNumber || externalId || id;
};
export var getEmployeeLabel = function getEmployeeLabel(employee) {
  var employeeName = getEmployeeName(employee);
  var employeeId = getEmployeeId(employee);

  if (employeeName && employeeId) {
    return "".concat(employeeId, " - ").concat(employeeName);
  }

  if (employeeName) {
    return employeeName;
  }

  if (employeeId) {
    return employeeId;
  }

  return '';
};